export default __webpack_public_path__ + "static/media/product_4.1.3c8ecc49.jpg";